import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TravelPartner from '../../components/travel_partner';
import './expense_management.css';
import BottomSignupGradient from '../../components/bottom_signup_gradient';

// SVGs
import ExpenseManagement1SVG from '../../assets/expense_management/Expense_header.svg';
import ExpenseManagementSec2 from '../../components/expense_management_sec2';
import AppNavBar from '../../helper/appbar';

const ExpenseManagement = () => {
    const freeSignUp = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
    return (
        <main>
            <AppNavBar navType={'dark'} />
            <section className='expense_section_1'>
                <Container>
                    <Row>
                        <Col sm={12} lg={6}>
                            <h1>Get rid of manual reporting.</h1>
                            <p>Maintain a happy and productive workforce by automating travel expense and streamlining approvals.</p>
                            <button onClick={freeSignUp}>Get started <ArrowForwardIcon sx={{ color: "#40798c" }} /></button>
                        </Col>
                        <Col sm={12} lg={6}>
                            <img src={ExpenseManagement1SVG} alt="expense_section_1_img" loading="lazy" />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='expense_section_2'>
                <Container fluid>
                    <ExpenseManagementSec2 />
                </Container>
            </section>

            <section className="expense_section_3">
                <img src={require("../../assets/expense_management/section_3_avatar.png")} alt="section_3_avatar" />
                <aside>
                    <p>We have had so much trouble reconciling travel expenses. Kardinal is a
                        simple solution to this problem, which I wonder why there hasn't
                        been an automation platform.</p>
                    <p><strong>Biola, </strong>Chocolate City Music</p>
                </aside>
            </section>

            {/* Section 4th */}
            <TravelPartner />

            {/* Section 5th */}
            <section className='expense_section_5'>
                <BottomSignupGradient
                    type={`Get full control on your business travel.`}
                />
            </section>

        </main>
    );
};

export default ExpenseManagement;